import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  className = '',
  ...props
}) => {
  return (
    <div className="mb-4 flex w-full flex-col">
      {label && <label className="form-label">{label}</label>}
      <input
        className={`form-input ${error ? 'border-rose-400 focus:border-rose-500' : ''} ${className}`}
        {...props}
      />
      {error && <span className="mt-1 text-xs text-rose-600">{error}</span>}
    </div>
  );
};

